export default {
  play: '지금 플레이',
  fullscreen: '전체 화면 모드',
  addToFavorites: '즐겨찾기에 추가',
  removeFromFavorites: '즐겨찾기에서 제거',
  similarGames: '비슷한 게임',
  howToPlay: '게임 방법',
  gameDescription: '게임 설명',
  controlsAndInstructions: '조작법과 설명',
  share: '공유',
  gameUnavailable: '게임을 사용할 수 없습니다',
  tryAgainLater: '이 게임은 현재 사용할 수 없습니다. 나중에 다시 시도해주세요.',
  openInNewTab: '새 탭에서 열기',
  gameTitle: '게임 제목',
  genres: '게임 장르',
  tags: '태그',
  noGenre: '장르 없음',
  noTags: '태그 없음',
  new: '신규 게임',
  playAmazingGame: '이 멋진 게임을 지금 바로 플레이하세요!',
  noSimilarGames: '비슷한 게임이 없습니다',
  gameNotFound: '게임을 찾을 수 없습니다',
  gameNotExistOrRemoved: '찾으시는 게임이 존재하지 않거나 삭제되었습니다.',
  backToHome: '홈으로 돌아가기',
  seoTitle: '{title} - 온라인 플레이 - GoGameVault',
  seoTitleNotFound: '게임을 찾을 수 없습니다 - GoGameVault',
  seoKeywords: '{title} 플레이, 무료 온라인 게임, {tags} 게임',
  gameFeatures: '게임 특징',
  controlDetails: '조작법 상세'
}; 